import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Tabs,
  Tab,
  AppBar,
  withStyles,
} from '@material-ui/core'

import { LIST_TYPE, ROUTES } from '../constant'
import { getPendingRefundTransactions, getSuccessfulRefundTransactions, triggerRefundTransactions } from '../actions/transaction'
import Button from '../components/Button'
import Loading from '../components/Loading'
import Section from '../components/Section'
import TabPanel from '../components/TabPanel'
import Breadcrumb from '../components/Breadcrumb'
import TableAutomation from '../components/TableAutomation'

const styles = () => ({
  root: {},
})


class ListRefund extends Component {
  /* LIFECYCLE */

  constructor(props) {
    super(props)

    this.state = {
      tabIndex: 0,
      selected: [],
    }
  }


  /* METHODS */

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleTabChange = (e, nextValue) => this.setState({
    selected: [],
    tabIndex: nextValue,
  })

  renderTransaction = (transaction) => {
    return [
      transaction.id,
      { data: transaction.user.phone, display: <Link to={`${ROUTES.USER}/${transaction.user.id}`}>{transaction.user.phone}</Link> },
      transaction.created_at ? moment(transaction.created_at).format('DD/MM/YYYY - HH:mm') : 'N/A',
      { data: transaction.shop.name, display: <Link to={`${ROUTES.MARKET}/${transaction.shop.id}`}>{transaction.shop.name}</Link> },
      `${transaction.amount} €`,
      transaction.refund_date ? moment(transaction.refund_date.toDate()).format('DD/MM/YYYY - HH:mm') : 'N/A',
    ]
  }

  handleRefundTransactions = async () => {
    const transactionIds = this.state.selected.slice(0)

    try {
      await this.props.triggerRefundTransactions(transactionIds)
      this.props.getPendingRefundTransactions()
    } catch (err) {
      console.err(err)
    }

    return this.setState({ selected: [] })
  }

  handleTransactionPageChange = () => {
    this.setState({ selected: [] })
  }

  handleClickTransaction = (item) => {
    const { selected } = this.state
    const isSelected = selected.includes(item.id)

    return this.setState({
      selected: isSelected ? selected.filter(x => x !== item.id) : selected.concat(item.id),
    })
  }

  handleToggleSelectAllTransactions = () => {
    const { selected } = this.state

    if (selected.length > 0) {
      return this.setState({ selected: [] })
    }

    return this.setState({ selected: (this.props.items || []).map(item => item.id) })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      items,
      classes,
      hasMore,
      isLoading,
      endBefore,
      startAfter,
      hasPrevious,
    } = this.props

    const {
      selected,
      tabIndex,
    } = this.state

    return (
      <div className={classes.root}>
        <Breadcrumb
          data={[
            { label: 'Accueil', to: '/' },
            'Remboursements',
          ]}
        />

        {isLoading && <Loading />}

        <Section disableArrow title="Liste des transactions remboursées">
          <AppBar position="static" color="default">
            <Tabs centered value={tabIndex} onChange={this.handleTabChange}>
              <Tab label="Remboursés" />
              <Tab label="Non remboursés" />
            </Tabs>
          </AppBar>


          <TabPanel hidden={tabIndex !== 0}>
            <TableAutomation
              disableMargin
              items={items}
              hasMore={hasMore}
              endBefore={endBefore}
              startAfter={startAfter}
              hasPrevious={hasPrevious}
              row={this.renderTransaction}
              request={this.props.getSuccessfulRefundTransactions}
              head={['ID', 'Utilisateur', 'Date', 'Commerce', 'Montant', 'remboursement']}
            />
          </TabPanel>

          <TabPanel hidden={tabIndex !== 1}>
            <TableAutomation
              disableMargin
              selectable
              items={items}
              hasMore={hasMore}
              selected={selected}
              endBefore={endBefore}
              startAfter={startAfter}
              hasPrevious={hasPrevious}
              row={this.renderTransaction}
              onClick={this.handleClickTransaction}
              onPageChange={this.handleTransactionPageChange}
              request={this.props.getPendingRefundTransactions}
              onToggleSelectAll={this.handleToggleSelectAllTransactions}
              head={['ID', 'Utilisateur', 'Date', 'Commerce', 'Montant', 'Actions']}
            />
            <br />
            <Button
              fullWidth
              isLoading={isLoading}
              disabled={!selected.length}
              className={classes.marginTop}
              onClick={this.handleRefundTransactions}
            >
              Marquer {selected.length} transaction{selected.length > 0 ? 's' : ''} comme remboursée{selected.length > 0 ? 's' : ''}
            </Button>
          </TabPanel>
        </Section>
      </div>
    )
  }
}


ListRefund.propTypes = {
  hasMore: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  endBefore: PropTypes.string,
  startAfter: PropTypes.string,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  triggerRefundTransactions: PropTypes.func.isRequired,
  getPendingRefundTransactions: PropTypes.func.isRequired,
  getSuccessfulRefundTransactions: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  endBefore: state.list.endBefore,
  startAfter: state.list.startAfter,
  items: state.list.type === LIST_TYPE.REFUNDS ? state.list.items : [],
  hasMore: state.list.type === LIST_TYPE.REFUNDS ? state.list.hasMore : false,
  hasPrevious: state.list.type === LIST_TYPE.REFUNDS ? state.list.hasPrevious : false,
})


export default connect(mapStateToProps, {
  triggerRefundTransactions,
  getPendingRefundTransactions,
  getSuccessfulRefundTransactions,
})(withStyles(styles)(ListRefund))
